import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from './AuthProvider';

export function AuthenticatedAlready() {
  const { isLoggedIn } = useAuth();

  return isLoggedIn ? <Navigate to="/home" /> : <Outlet />;
}
